export interface CandyPopdProtocol {
    resultCode: PopdResultCode;
    contentDriveUri: string;
    errorsCount: number;
    warningsCount: number;
    message: string;
}

export interface CandyPopdProtocolState {
    isChecking?: boolean;
    resultCode?: PopdResultCode;
    contentDriveUri?: string;
    errorsCount?: number;
    warningsCount?: number;
    message?: string;
}

export enum PopdResultCode {
    Ok = "Ok",
    Error = "Error",
}
